import { Box, Button, ButtonGroup, SxProps, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { useGetUserMeQuery } from '../../../../services/entities/impl/blfApi/endpoints/users';
import { UserRolesEnum } from '../../../../services/entities/impl/blfApi/schemas/user';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { flexCenter } from '../../../commonUI/cssClasses';
import { hasAuthorizedRole } from '../../../commonUtils';
import {
  OnboardFormStepEnum,
  selectOnboardFormStep,
  setOnboardFormStep,
} from '../../onboardingSlice';

const OnboardFormStepButtons: React.FC = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const onboardFormStep = useAppSelector(selectOnboardFormStep);
  const { data: user } = useGetUserMeQuery();
  const isAuthorized = hasAuthorizedRole([UserRolesEnum.root], user);

  const commonButtonStyles: SxProps = {
    borderColor: theme.colors.darkTheme.grey.muted,
    bgcolor: theme.colors.darkTheme.grey.dark,
    '&:hover': {
      bgcolor: theme.colors.darkTheme.grey.medium,
      borderColor: theme.colors.darkTheme.grey.muted,
    },
    color: theme.colors.common.white,
    fontSize: '1rem',
    fontWeight: 700,
    '&:disabled': {
      color: theme.colors.darkTheme.grey.light,
      bgcolor: theme.colors.darkTheme.grey.dark,
      opacity: 0.8,
      borderColor: theme.colors.darkTheme.grey.muted,
    },
  };

  const steps = [
    OnboardFormStepEnum.Add,
    OnboardFormStepEnum.View,
    OnboardFormStepEnum.Edit,
    OnboardFormStepEnum.Delete,
  ];

  return (
    <Box
      sx={{
        width: '100%',
        ...flexCenter,
      }}
    >
      <ButtonGroup
        variant='outlined'
        aria-label='outlined button group'
        color='secondary'
        size='large'
        fullWidth
      >
        {steps.map((step) => (
          <Button
            key={step}
            sx={{
              ...commonButtonStyles,
              ...(onboardFormStep === step && {
                color: theme.colors.common.bloomfieldGreen,
              }),
            }}
            onClick={() => dispatch(setOnboardFormStep(step))}
            // Allow anyone to view the form, but only authorized users can add, edit, or delete
            disabled={step !== OnboardFormStepEnum.View && !isAuthorized}
          >
            {t(step, { ns: 'common' })}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default OnboardFormStepButtons;
